import React from "react";
import baseContentLayout from "../../shared/base-content/index";
import "./index.scss";
import CreateDialog from "./dialog/create";
import DeleteDialog from "./dialog/delete";
import MyButton from "../../shared/buttons/primary";
import * as actions from "../../../modules/setting/actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import { COUNTER_TABLE, TABLE_TYPE_MAP } from "../../../constants/app";

const Content = (props) => {
  const LIMIT = 20;
  const globalState = window.store.getState();
  const [listTable, setListTable] = React.useState([]);
  const [keyword, setKeyword] = React.useState("");
  const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
  const [dialogData, setDialogData] = React.useState({});
  const [showModelByType, setShowModelByType] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [resetPagination, setResetPagination] = React.useState(0);
  const [isReset, setIsReset] = React.useState(0);

  React.useEffect(() => {
    setListTable(globalState.setting.listTable);
  }, [globalState.setting.listTable]);

  const deleteBtnClick = async (data) => {
    await setDialogData(data);
    setDeleteDialogShow(true);
  };

  React.useEffect(() => {
    reloadSeat();
  }, [currentPage, isReset]);

  const reloadSeat = () => {
    const { dispatchActions } = props;
    const queryParams = {
      shopId: props.auth.user.id,
      query: {
        name: keyword.trim(),
        page: currentPage,
        page_size: LIMIT,
      },
    };
    dispatchActions.getListTable(queryParams);
  };

  const onCloseModel = (data) => {
    setShowModelByType(null);
    if (!window.utils.isEmptyObject(data)) {
      if (showModelByType === "create") {
        setResetPagination(resetPagination + 1);
        setCurrentPage(1);
      }
      reloadSeat();
    }
  };

  const onCloseDeleteDialog = (data) => {
    setDeleteDialogShow(false);
    if (!window.utils.isEmptyObject(data)) {
      reloadSeat();
    }
  };

  const createBtnClick = () => {
    setDialogData({});
    setShowModelByType("create");
  };

  const editBtnClick = (data) => {
    setDialogData(data);
    setShowModelByType("update");
  };

  const handleSearch = () => {
    setCurrentPage(1);
    setResetPagination(resetPagination + 1);
    setIsReset(isReset + 1);
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(+selected + 1);
  };

  return (
    <div className="table-seat">
      <div className="table-seat__search mb-4 d-flex align-items-center">
        <div className="me-3">
          <div className="table__search">
            <div className="form-group d-inline-block me-3">
              <input
                type="text"
                className="form-control no-box-shadow d-inline-block"
                placeholder="座席名"
                value={keyword}
                onChange={(e) => {
                  const { value } = e.target;
                  setKeyword(value);
                }}
                onKeyUp={(event) => {
                  if (event.key === "Enter") {
                    handleSearch();
                  }
                }}
              />
            </div>
            <MyButton myVariant="search" onClick={handleSearch}>
              検索
            </MyButton>
          </div>
        </div>
        <MyButton myVariant="add" onClick={createBtnClick}>
          ＋ 座席を追加
        </MyButton>
      </div>
      <div className="history__table table-seat__table">
        <table className="table">
          <thead className="">
            <tr>
              <th scope="col" className="col-username">
                座席名
              </th>
              <th scope="col" className="col-default">
                座席タイプ
              </th>
              <th scope="col" className="col-default">
                席数
              </th>
              <th scope="col" className="col-default">
                予約可能最小人数
              </th>
              <th scope="col" className="col-default">
                補助イス数
              </th>
              <th scope="col" className="col-default">
                備考
              </th>
              <th scope="col" className="col-activity">
                操作
              </th>
            </tr>
          </thead>
          <tbody>
            {listTable.results && listTable.results?.length ? (
              listTable.results?.map((item) => {
                return (
                  <tr key={item.id}>
                    <td>
                      {window._.truncate(item.name, {
                        length: 30,
                        omission: "...",
                      })}
                    </td>
                    <td>{TABLE_TYPE_MAP[item.table_type] || ""}</td>
                    <td>{item.seats ? `${item.seats}席` : ""}</td>
                    <td>{item.min_seats ? `${item.min_seats}席` : ""}</td>
                    <td>{item.extra_seats ? `${item.extra_seats}席` : ""}</td>
                    <td>
                      {window._.truncate(item.detail, {
                        length: 80,
                        omission: "...",
                      })}
                    </td>
                    <td className="buttons">
                      <MyButton
                        className="me-2"
                        myVariant="edit"
                        onClick={() => editBtnClick(item)}
                      >
                        編集
                      </MyButton>
                      <MyButton
                        myVariant="delete"
                        onClick={() => deleteBtnClick(item)}
                      >
                        削除
                      </MyButton>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="5">データなし</td>
              </tr>
            )}
          </tbody>
        </table>
        {listTable.count > LIMIT ? (
          <ReactPaginate
            key={resetPagination}
            previousLabel={<span className="material-icons">chevron_left</span>}
            nextLabel={<span className="material-icons">chevron_right</span>}
            disabledClassName={"navigation-disabled"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={Math.ceil(listTable.count / LIMIT) || 1}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={"my-pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
          />
        ) : (
          ""
        )}
      </div>
      {showModelByType && (
        <CreateDialog
          showByType={showModelByType}
          onclose={onCloseModel}
          detailData={dialogData}
        />
      )}
      {deleteDialogShow && (
        <DeleteDialog
          isShow={deleteDialogShow}
          onClose={onCloseDeleteDialog}
          data={dialogData}
        />
      )}
    </div>
  );
};
const TableContent = baseContentLayout(Content);

class index extends React.Component {
  render() {
    return <TableContent name="座席設定" {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchActions: bindActionCreators({ ...actions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(index);
